import React, { PureComponent } from 'react';
import sleep from 'sleep-promise';
import Header from '../components/DRHeader';
import Styles, { noSelect, cancelColor, confirmColor, confirmBorderColor } from '../constants/Styles';
import { DRNoteInput } from '../components/DRControls';
import { START_GOAL, END_GOAL, HorizontalButtonPairView } from '../components/DRViewUtils';
import { elasticLogTaskAction, elasticLogEvent, elasticLogError } from '../vodjs/ElasticLog';
import { makeId, isMobile, isWideMobile } from '../vodjs/Utils';
import WebPicker from '../components/WebPicker';
import { DRButton } from '../components/DRControls';
import RestrictedCheckbox from '../components/RestrictedCheckbox';
import { makeTaskDecorator } from '../vodjs/Task';

import TaskRequest from '../vodjs/TaskRequest';

import { getUnitWp, getDeliveryType, h2r } from '../vodjs/lib';
import MoxiModalContext from '../components/MoxiModalContext';
import { getConfig } from '../utils/configUtils';
import { REQUIRED_ROLE } from '../constants/Tasks';

const mobile = isMobile();

const PLEASE_SELECT = 'Please select...';

export default class SendScreen extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      taskType: getDeliveryType(),
      title: props.title,
      startGoalText: !!props.startGoalText ? props.startGoalText : '',
      endGoalText: !!props.endGoalText ? props.endGoalText : '',
      startGoal: props.defaultStartGoal, //this.startGoals[0].value,
      endGoal: PLEASE_SELECT,
      noteContent: '',
      isLoading: false,
      alertMsg: undefined,
    };

    this.setStartGoal = this.setStartGoal.bind(this);
    this.setEndGoal = this.setEndGoal.bind(this);
    this.generateTaskRequestArgs = this.generateTaskRequestArgs.bind(this);
    this.generateTaskRequestData = this.generateTaskRequestData.bind(this);
    this.onNoteInputChange = this.onNoteInputChange.bind(this);
    this.handleDimensionChange = this.handleDimensionChange.bind(this);

    if (mobile) this.state.wideMobile = isWideMobile();
  }

  handleDimensionChange(event) {
    if (mobile) this.setState({ wideMobile: isWideMobile() });
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleDimensionChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleDimensionChange);
  }

  setStartGoal(itemValue, itemIndex) {
    this.setState({ startGoal: itemValue });
  }

  setEndGoal(itemValue, itemIndex) {
    this.setState({ endGoal: itemValue });
  }

  generateTaskRequestArgs() {
    let taskRequestArgs = {
      start_is_room: false,
      end_is_room: false,
    };

    taskRequestArgs[START_GOAL] = h2r(this.state.startGoal);
    taskRequestArgs[END_GOAL] = h2r(this.state.endGoal);

    return taskRequestArgs;
  }


  generateTaskRequestData() {
    return {
      sender_note: (this.state.noteContent || '').trim(), //for non-batch tasks, need to guarantee NO trailing CRs
    };
  }


  async createTask(cleared) {

    if (this.state.endGoal == PLEASE_SELECT) {
      this.setState({ alertMsg: {msg:'You must select a destination.'} });
      return;
    }

    if(!cleared) {
      let openHoursInfo = this.props.getOpenHoursInfo(h2r(this.state.endGoal));
      if(openHoursInfo) {
        let yesCB = openHoursInfo.userChoices ? (() => this.setState({alertMsg:openHoursInfo}, () => this.createTask(true))) : undefined;
        this.setState({alertMsg:{...openHoursInfo, yesCB}});
        return;
      }
    }

    let appTaskRequestId = makeId(4);
    const userTaskRequestTime = new Date().toISOString();
    let taskRequestArgs = this.generateTaskRequestArgs();
    let { start_goal, end_goal } = taskRequestArgs;
    elasticLogTaskAction({ what: 'taskRequested', appTaskRequestId, userTaskRequestTime, start_goal, end_goal });

    this.setState({ isLoading: true });

    let response;

    let exit = (message) => {
      elasticLogError({ what: 'createTask', appTaskRequestId, start_goal, end_goal, message });
      this.setState({ isLoading: false });
      this.props.closeModal({ title: 'Error requesting task', message });
    };

    try {
      response = await TaskRequest.request(
        getUnitWp(),
        this.state.taskType,
        this.props.isRestricted ? REQUIRED_ROLE.RESTRICTED : REQUIRED_ROLE.BASIC,
        taskRequestArgs,
        this.generateTaskRequestData(),
        false,
      );
    }
    catch (error) {
      return exit('request: ' + error.message);
    }

    const taskUuid = response.task_uuid;
    elasticLogEvent({ what: 'taskCreated', appTaskRequestId, userTaskRequestTime, taskUuid, start_goal, end_goal });

    if (getConfig().secureDelivery) {
      try {
        let decorator;
        let start = Date.now();

        decorator = makeTaskDecorator((uuid) => this.props.tasks.find((t) => t.uuid === uuid));
        decorator.add({ uuid: taskUuid, data: { restricted: !!this.props.isRestricted } }); // undefined will cause firestore errs, so !! to force to boolean
        decorator.allTaskUuidsAdded();

        while (Date.now() < start + 1000 * 10) {
          if (decorator.isDone()) break;
          await sleep(250);
        }
      }
      catch (e) {
        elasticLogError({ what: 'createRestrictedTask', appTaskRequestId, start_goal, end_goal, errorStr: e.message });
      }
    }

    this.setState({ isLoading: false });
    this.props.closeModal(false);
  }

  onNoteInputChange(text) {
    this.setState({ noteContent: text });
  }

  // closeLoader = () => this.setState({loaderVisible: false})

  render() {
    let buttonSettings = [
      {
        phrase: 'CANCEL',
        borderColor: cancelColor,
        fillColor: 'transparent',
        fontColor: cancelColor,
        action: () => this.props.closeModal(),
      },
      {
        phrase: 'REQUEST',
        fillColor: confirmColor,
        borderColor: confirmBorderColor,
        fontColor: 'white',
        disabled: !this.state.startGoal || !this.state.endGoal,
        action: () => {
          if (!this.state.isLoading)
            //debounce
            this.createTask();
        },
      },
    ];

    let ordStr =
      {
        0: 'first',
        1: 'second',
        2: 'third',
        3: 'fourth',
        4: 'fifth',
        5: 'sixth',
      }[this.context.queueLength] || 'number ' + (this.context.queueLength + 1);

    let wideMobile = this.state.wideMobile;

    return (
      <div
        style={{
          ...Styles.container,
          marginLeft: 20,
          marginRight: 20,
          marginBottom: 20,
          display: 'flex',
          flexFlow: 'column',
          position: 'relative',
        }}
        behavior={'padding'}
      >
        <div style={{ flex: 1, alignItems: 'center', display: 'flex', flexFlow: 'column' }}>
          {!mobile && <Header showBackBt={false} />}

          {!mobile && (
            <div
              style={{
                fontWeight: 700,
                fontSize: 24,
                marginTop: 15,
                ...noSelect,
                alignSelf: 'center',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                flexFlow: 'column',
              }}
            >
              {this.state.title}
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <div style={{ flex: 1 }} />

            <div style={{ display: 'flex', flexFlow: 'column', alignItems: 'center', margin: 10 }}>
              {!!this.state.endGoalText && <div style={styles.goalText}> {this.state.endGoalText} </div>}
              <WebPicker
                itemStyle={{ height: 150, textAlign: 'center' }}
                style={{ border: '1px solid black', borderRadius: 6, cursor: 'pointer', padding: 4 }}
                id={'end'}
                onValueChange={(itemValue) => this.setEndGoal(itemValue)}
                selectedValue={this.state.endGoal}
                disabledValues={[this.props.noKioskText]}
                values={[PLEASE_SELECT, ...this.props.endGoals]}
              />
            </div>

            <div style={{ flex: 1 }} />
          </div>
          {!mobile && !!this.context.taskQueue && (
            <div style={styles.queueText}>{`You'll be ${ordStr} in the queue.`}</div>
          )}
          {getConfig().secureDelivery && this.props.showRestricted && (
            <div style={{ marginBottom: 8 }}>
              <RestrictedCheckbox
                isChecked={this.props.isRestricted}
                handleChange={(e) => this.props.setRestricted(e.target.checked)}
              />
            </div>
          )}
          <DRNoteInput
            textInputStyle={{ width: '90%', backgroundColor: '#F4F4F4', fontSize: mobile ? 12 : 20, flex: 1 }}
            onChangeText={this.onNoteInputChange}
            placeholderText="Add a note..."
          />
          <div style={{ marginTop: mobile ? 10 : 20, height: 92, marginLeft: 15, marginRight: 15, width: '100%' }}>
            <HorizontalButtonPairView buttonSettings={buttonSettings} />
          </div>
        </div>

        {this.state.isLoading && (
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              backgroundColor: 'white',
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div style={{ color: 'black', fontSize: 30, fontStyle: 'italic' }}>Requesting task, please wait...</div>
          </div>
        )}

        {!!this.state.alertMsg && (
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              backgroundColor: 'white',
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding:40
            }}
          >
            <div style={{ color: 'black', fontSize: 30, marginBottom: 20, textWrap:'balance', textAlign:'center' }}>{this.state.alertMsg.msg}</div>

            <div style={{display:'flex', flexFlow:'row', alignItems:'center'}}>

              {!!this.state.alertMsg.userChoices && <DRButton
                style={{marginRight:30 }}
                action={() => this.state.alertMsg.yesCB()}
                phrase={this.state.alertMsg.userChoices.yes}
                fontColor={'black'}
                borderColor={'black'}
              />}

              <DRButton
                style={{flex: 1 }}
                action={() => this.setState({ alertMsg: undefined })}
                phrase={this.state.alertMsg.userChoices?.no || 'OK'}
                fontColor={'black'}
                borderColor={'black'}
              />

            </div>

          </div>
        )}
      </div>
    );
  }
}

SendScreen.contextType = MoxiModalContext;
SendScreen.navigationOptions = {
  header: null,
};

const styles = {
  goalText: {
    fontSize: 24,
    marginTop: 5,
    alignSelf: 'center',
    userSelect: 'none',
    fontWeight: 'bold',
  },
  queueText: {
    fontSize: 21,
    marginTop: 16,
    marginBottom: 16,
    alignSelf: 'center',
  },
};
